import { useState, type FormEvent } from "react";
import { useAuth } from "../auth/AuthContext.js";
import { api, ApiError } from "../api/client.js";
import { TellYourFriendsCard } from "../components/TellYourFriendsCard.js";

export function AccountPage() {
  const { user, csrfToken } = useAuth();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  async function handleSubmit(event: FormEvent): Promise<void> {
    event.preventDefault();
    setError(null);
    setSuccess(false);
    if (newPassword !== confirmPassword) {
      setError("New passwords do not match.");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/auth/change-password", csrfToken, { currentPassword, newPassword });
      setSuccess(true);
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Password change failed — please try again.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div>
      <h2>Account</h2>
      <div className="card">
        <h3>Profile</h3>
        <p>
          <strong>Email:</strong> {user?.email}
        </p>
        <p>
          <strong>Email verified:</strong> {user?.emailVerified ? "Yes" : "No"}
        </p>
      </div>
      <div className="card">
        <h3>Change password</h3>
        {error && <div className="error-banner">{error}</div>}
        {success && <div className="success-banner">Password changed. Your other sessions have been signed out.</div>}
        <form onSubmit={(event) => void handleSubmit(event)}>
          <div className="field">
            <label htmlFor="currentPassword">Current password</label>
            <input id="currentPassword" type="password" required autoComplete="current-password" value={currentPassword} onChange={(event) => setCurrentPassword(event.target.value)} />
          </div>
          <div className="field">
            <label htmlFor="newPassword">New password</label>
            <input id="newPassword" type="password" required minLength={12} autoComplete="new-password" value={newPassword} onChange={(event) => setNewPassword(event.target.value)} />
          </div>
          <div className="field">
            <label htmlFor="confirmPassword">Confirm new password</label>
            <input id="confirmPassword" type="password" required minLength={12} autoComplete="new-password" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} />
          </div>
          <button type="submit" className="primary" disabled={submitting}>
            {submitting ? "Changing…" : "Change password"}
          </button>
        </form>
      </div>
      <TellYourFriendsCard />
    </div>
  );
}
